__turbopack_context__.v({
  "empty": "X6Ns7a_empty",
  "filled": "X6Ns7a_filled",
  "half": "X6Ns7a_half",
  "ratingLabel": "X6Ns7a_ratingLabel",
  "star": "X6Ns7a_star",
  "stars": "X6Ns7a_stars",
});
